// Imagens e fundos externos de e-mails são bloqueados por padrão: um pixel remoto revela ao
// remetente que o e-mail foi aberto, quando e o IP de quem abriu. Imagens embutidas (data:) e
// arquivos servidos pelo próprio painel (anexos inline) continuam carregando.

const REMOTE_PATTERN = /^\s*(https?:)?\/\//i;
const INLINE_IMAGE_PATTERN = /^\s*data:image\//i;

const isSameOrigin = (url, origin) => {
  try {
    return new URL(url, origin).origin === origin;
  } catch {
    return false;
  }
};

export const isRemoteResource = (url, origin) =>
  REMOTE_PATTERN.test(String(url || '')) && !isSameOrigin(url, origin);

// Função entregue ao sanitizador (rewriteExternalResources) para src e url() do CSS.
export const buildResourceRewriter =
  ({ allowRemote = false, origin = window.location.origin } = {}) =>
  url => {
    const value = String(url || '').trim();
    if (INLINE_IMAGE_PATTERN.test(value)) return value;
    if (!/^(https?:)?\/\//i.test(value) && !value.startsWith('/')) return '';
    if (allowRemote || isSameOrigin(value, origin)) return value;
    return '';
  };

const RESOURCE_URL_PATTERN =
  /(?:\bsrc\s*=\s*["']?|\bbackground\s*=\s*["']?|url\(\s*["']?)([^"'\s)>]+)/gi;

export const hasRemoteResources = (html, origin = window.location.origin) => {
  if (!html) return false;
  return [...String(html).matchAll(RESOURCE_URL_PATTERN)].some(([, url]) =>
    isRemoteResource(url, origin)
  );
};
